import type { JSX } from 'react';
import Loadable, { LoadingSpinner as LoadingComponent } from '@comeon/loadable';

// FIXME type casting
const Loading = LoadingComponent as unknown as JSX.Element | null;

const DELAY = 300;

export const Login = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "login" */
			'./login/login'
		),
	loading: Loading,
	delay: DELAY
});

export const RegistrationTrustlyInfo = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "registration-trustly-info" */
			'./register/registration-trustly-info'
		),
	loading: Loading,
	delay: DELAY
});

export const PlayNow = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "play-now" */
			'./playnow'
		),
	loading: Loading,
	delay: DELAY
});

export const ReCaptcha = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "recaptcha" */
			'./recaptcha/index'
		),
	loading: Loading,
	delay: DELAY
});

export const CampaignRegistration = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "campaign-registration" */
			'./register/campaign-registration'
		),
	loading: Loading,
	delay: DELAY
});

export const TwoFactor = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "two-factor" */
			'./two-factor/two-factor'
		),
	loading: Loading,
	delay: DELAY
});

export const PhoneVerification = Loadable({
	loader: () => import('./phone-verification/phone-verification-container'),
	loading: Loading,
	delay: DELAY
});

export const MissingData = Loadable({
	loader: () => import('./missing-data/missing-data-container'),
	loading: Loading,
	delay: DELAY
});

export const LugasLogin = Loadable({
	loader: () => import('./lugas/lugas-login'),
	loading: Loading,
	delay: DELAY
});

export const SocialMediaWrapper = Loadable({
	loader: () => import('./social-media/wrapper'),
	loading: Loading,
	delay: DELAY
});

export const TemporaryAccountExpired = Loadable({
	loader: () => import('./temporary-account'),
	loading: Loading,
	delay: DELAY
});

export const SchufaVerification = Loadable({
	loader: () => import('./schufa-verification'),
	loading: Loading,
	delay: DELAY
});

export const SEON = Loadable({
	loader: () => import('./seon'),
	loading: Loading
});
